export default "__VITE_ASSET__B$oyfoNi__"